import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { uniqueId } from 'lodash';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';
import { Matrix, MatrixItem } from 'contest/components/matrix';
import Mediabox from 'contest/components/mediabox';

export const ViewImageChoiceOtherElement = ({ value, label, image }) => {
    if (value.choice) {
        return (
            <Matrix large={5} normal={5} medium={5} small={5}>
                <MatrixItem>
                    <Mediabox variations={['wide-meta']} meta={label}>
                        <img src={image} />
                    </Mediabox>
                </MatrixItem>
            </Matrix>
        );
    } else {
        return <p>{value.other}</p>;
    }
};
ViewImageChoiceOtherElement.propTypes = {
    value: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
};

export const ConnectedViewImageChoiceOtherElement = connectReadElement(
    ViewImageChoiceOtherElement,
    element => ({
        value: element.value,
        label: element.value.choice ? element.trans.choices[element.value.choice] : '',
        image: element.value.choice ? element.assets[element.value.choice] : '',
    }),
    ({ value }) => value.other != null || value.choice != null
);

export class EditImageChoiceOtherElement extends Component {
    constructor(props) {
        super(props);

        this.handleSave = this.handleSave.bind(this);
        this.handleChoiceChange = this.handleChoiceChange.bind(this);
        this.handleOtherChange = this.handleOtherChange.bind(this);

        const hasChoice = props.value.hasOwnProperty('choice');
        this.state = {
            choice: hasChoice ? props.value.choice : props.otherKey,
        };

        this.radioGroupName = uniqueId('image-choice-other_');
    }

    handleSave() {
        return this.props.onSave();
    }

    handleChoiceChange(event) {
        const choice = event.target.value;
        this.setState({ choice }, () => {
            if (!this.isOtherSelected()) {
                let value = this.state.choice;
                if (value == '') {
                    value = null;
                }
                this.props.onChange(
                    {
                        choice: value,
                    },
                    true
                );
            }
        });
    }

    handleOtherChange(event) {
        this.props.onChange(
            {
                other: event.target.value,
            },
            false
        );
    }

    render() {
        const { choices, images } = this.props;
        return (
            <div>
                <Matrix large={5} normal={5} medium={4} small={3}>
                    {Object.keys(choices).map(key => (
                        <MatrixItem key={key}>
                            <div
                                className="field field--checkable field--checkable-image m-none-bottom"
                                data-field-selected={this.state.choice == key ? true : null}
                            >
                                <label>
                                    <div className="field__image">
                                        <img src={images[key]} />
                                    </div>
                                    <div className="field__input">
                                        <input
                                            name={this.radioGroupName}
                                            type="radio"
                                            className="input-radio"
                                            value={key}
                                            checked={this.state.choice == key}
                                            onChange={this.handleChoiceChange}
                                        />
                                    </div>
                                    <span className="field__title">{choices[key]}</span>
                                </label>
                            </div>
                        </MatrixItem>
                    ))}
                </Matrix>
                {this.renderOther()}
            </div>
        );
    }

    renderOther() {
        const key = this.props.otherKey;
        const label =
            this.props.otherOption ||
            this.props.intl.formatMessage({ id: 'brief_choice_other_option' });
        const selected = this.isOtherSelected();
        const id = uniqueId('image-choice-other__other-field_');
        return (
            <div className="field field--checkable">
                <div className="field__input">
                    <input
                        id={id}
                        type="radio"
                        name={this.radioGroupName}
                        value={key}
                        checked={!!selected}
                        onChange={this.handleChoiceChange}
                    />
                </div>
                <div className="field__title">
                    <label htmlFor={id}>{label}</label>
                </div>
                {this.renderOtherInput()}
            </div>
        );
    }

    renderOtherInput() {
        if (this.isOtherSelected()) {
            return (
                <div className="field__children">
                    <div className="field">
                        <div className="field__input">
                            <input
                                type="text"
                                className="input-text input-width--max"
                                defaultValue={this.props.value.other}
                                placeholder={this.props.otherPlaceholder}
                                onChange={this.handleOtherChange}
                                onBlur={this.handleSave}
                                autoFocus={true}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }

    isOtherSelected() {
        return this.state.choice == this.props.otherKey;
    }
}
EditImageChoiceOtherElement.propTypes = {
    intl: PropTypes.object.isRequired,
    value: PropTypes.object.isRequired,
    choices: PropTypes.object.isRequired,
    images: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    otherKey: PropTypes.string,
    otherOption: PropTypes.string,
    otherPlaceholder: PropTypes.string,
};
EditImageChoiceOtherElement.defaultProps = {
    onChange: () => {},
    onSave: () => {},
    otherKey: '__other__',
    otherOption: '',
    otherPlaceholder: '',
};

export const ConnectedEditImageChoiceOtherElement = connectEditElementToBriefStore(
    injectIntl(EditImageChoiceOtherElement),
    element => ({
        value: element.value,
        choices: element.trans.choices,
        images: element.assets,
        otherOption: element.trans.otherOption,
        otherPlaceholder: element.trans.otherPlaceholder,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/image-choice-other-element.jsx